// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2Lgtd","error":"Textarea_error__NkFzm","readonly":"Textarea_readonly__CBQrn","disabled":"Textarea_disabled__5KJ1-"};